import GotoolsPollComponent from "./components/GotoolsPollComponent.component.vue";
Vue.component( "gotools-poll", GotoolsPollComponent );
